import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const VolumeUpIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "VolumeUp",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16.58 3.66c-.18-.07-.38-.12-.59-.12-.43 0-.82.18-1.1.46L9.12 9.77H3.56c-.86 0-1.55.69-1.56 1.55v9.35c0 .86.7 1.56 1.56 1.56h5.55L14.88 28c.28.28.67.45 1.1.45h.01c.21 0 .41-.04.59-.12.57-.23.96-.79.96-1.43V5.1c0-.65-.39-1.2-.95-1.44zm3.67 14.97c-.38.29-.63.74-.63 1.25 0 .86.69 1.55 1.55 1.55h.03c.34 0 .66-.12.91-.31a6.403 6.403 0 0 0 .02-10.23h-.02c-.26-.21-.58-.32-.93-.32-.86 0-1.56.7-1.56 1.56 0 .51.24.96.62 1.24.8.61 1.31 1.56 1.31 2.63s-.51 2.02-1.3 2.62Zm1.37-13.88a1.5 1.5 0 0 0-.44-.06c-.7 0-1.3.47-1.49 1.11-.04.14-.06.3-.06.45 0 .7.46 1.29 1.1 1.49h.01c3.59 1.09 6.16 4.38 6.16 8.26s-2.57 7.17-6.1 8.24l-.06.02c-.66.19-1.13.79-1.13 1.5 0 .86.7 1.56 1.56 1.56h.01c.16 0 .31-.02.45-.07h-.01c4.88-1.5 8.36-5.96 8.39-11.23-.02-5.28-3.51-9.75-8.3-11.24l-.08-.02Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M19.29 29.28q-.3 0-.57-.15L7.11 22.42H1c-.3 0-.59-.12-.81-.33a1.16 1.16 0 0 1-.33-.81V9.85c0-.63.51-1.14 1.14-1.14l6.04-.03L18.72 2c.35-.2.79-.2 1.14 0s.57.58.57.99v25.14c0 .41-.22.79-.57.99q-.27.15-.57.15ZM7.41 20.14c.2 0 .4.05.57.15l10.17 5.87V4.97L7.91 10.82c-.17.1-.36.15-.56.15l-5.2.03v9.15h5.26Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M6.71 17.86c-.63 0-1.14-.51-1.14-1.14v-2.29a1.14 1.14 0 1 1 2.28 0v2.29c0 .63-.51 1.14-1.14 1.14M23.86 24.8c-.55 0-1.03-.4-1.13-.95-.11-.62.31-1.21.94-1.32 3.42-.58 5.9-3.51 5.9-6.96s-2.48-6.39-5.9-6.96a1.147 1.147 0 0 1 .38-2.26c4.52.76 7.81 4.64 7.81 9.22s-3.28 8.45-7.81 9.22c-.06.01-.13.02-.19.02Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.86 19.04c-.39 0-.77-.2-.98-.56-.32-.54-.14-1.24.4-1.57.51-.3.81-.8.81-1.34s-.3-1.03-.81-1.34a1.15 1.15 0 0 1-.4-1.57 1.15 1.15 0 0 1 1.57-.4c1.21.72 1.93 1.95 1.93 3.31s-.72 2.59-1.93 3.3c-.18.11-.38.16-.58.16Z"
      })]
    })
  }));
};
VolumeUpIcon.displayName = 'VolumeUpIcon';